import React, { useState } from 'react';
import { validateEmail } from 'global/utils';

export function useEmail() {
    const [email, setEamil] = useState('');
    const [emailError, setEmailError] = useState('');

    const changeEmail = (value) => {
        setEamil(value);
    };

    const submitEmail = () => {
        if (!email) {
            setEmailError('Заполните Email');
        } else if (!validateEmail(email)) {
            setEmailError('Введите корректный email');
        } else {
            setEmailError('');
        }
    };

    return {
        email, emailError, changeEmail, submitEmail,
    };
}
